import React, { useEffect } from 'react'
import { useState } from 'react';
import { FaMapLocationDot } from "react-icons/fa6"
import { FcStatistics } from "react-icons/fc";
import { BsFillClipboard2DataFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { FaUsers } from "react-icons/fa6";
import { FaDatabase } from "react-icons/fa";
import { MdWork } from "react-icons/md";

import {BsArrowLeftShort,BsSearch} from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { TbLogout2 } from "react-icons/tb";
import { logoutStart } from '../state/authRedux';
import { logoutSuccess } from '../state/authRedux';
import { useNavigate } from 'react-router-dom';


export const RightMenu = ({open,setOpen,highlight}) => {
    //const [open,setOpen] = useState(true);
    const [menu,setMenu] = useState(0);
    const highlightIndex = useSelector((state)=>state.highlight.index)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const logOut = () => {
        dispatch(logoutSuccess())
        navigate('/login')
        console.log('logout now')
    }



    useEffect(()=>{
    })

  return (
        <div className={`xs:fixed xs:z-50 md:relative top-0 w-[50%] xs:h-screen  md:z-0 ${open?"xs:w-[90%]":"xs:w-[10%]"}  bg-[#1C1C1C] md:h-screen md:p-5 md:pt-8 ${open?"md:w-[15%]":"md:w-[5%]"} duration-300 relative`}>
            <ul className='pt-2'>
                <button onClick={()=>logOut()} className='text-gray-300 cursor-pointer gap-x-4 text-sm flex p-2 items-center hover:bg-slate-500 rounded-md w-[100%]'>
                    <span className='text-md block float-left'><TbLogout2/></span>
                    <span className='text-base font-medium'>Log Out</span>
                </button>
            </ul>
        </div>
    
    
  )
}